import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import L, { point } from "leaflet";
import { useLanguage } from "../../../Language/LanguageContext";

import AuthService from "../../../services/auth.service";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import AuthService_Operation from "../../../services/Operation.serviceV3";
import {
  MapContainer,
  TileLayer,
  Polygon,
} from "react-leaflet";
import UserOperationContentModal from "../../user/drone/UserOperationContentModal";
import Static_modal from "../../user/etc/Static_modal";
import { Button, Tooltip, Overlay, Spinner, Table, Modal } from "react-bootstrap";
import * as turf from "@turf/turf";
////React-Icon
import { RiFileExcel2Line } from "react-icons/ri";
import { TbDrone } from "react-icons/tb";
import { MdSettingsRemote } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { LuCopyPlus, LuCopyCheck, LuCopyMinus } from "react-icons/lu";
//Steps
import Plan_Status from "../../../Style_Component/Steps/Plan_Status";
//Prime
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";

//Icons
import { MdDateRange } from "react-icons/md";
import { FaUserAstronaut } from "react-icons/fa";
import { GiDeliveryDrone } from "react-icons/gi";
import docgif from "../../../picture/investigation.gif";

export default function MyOperation(prop) {
   const mapRef = useRef(null);
    const Navigate = useNavigate();
  const { t, changeLanguage, language, fontFamily } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [itemsA, setItemsA] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [target, setTarget] = useState(null);
    const [showErroroperation, setShowErroroperation] = useState(false);
  const [showInfomationA, setShowInfomationA] = useState(false);
  const [showInfomationB, setShowInfomationB] = useState(false);
  const [selectedInformation, setSelectedInformation] = useState([]);
  const [showApproveDroneList, setShowAprroveDroneList] = useState(false);
  const [showUserOperationModal, setShowUserOperationModal] = useState(false);
  const [cancancle, setCancancle] = useState(false);
  const handleToggleUserOperationModal = () => {
    setShowUserOperationModal(!showUserOperationModal);
  };
   const [member_joining, setMember_Joining] = useState([]);
  //modal config
  const [textBody, setTextBody] = useState();
  const [modalToggle, setModalToggle] = useState({
    showdata_check: false,
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const handleClose_Modal = () => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: false,
      modalDenied: false,
      modalErr: false,
      modalwait: false,
    });
    setTextBody("");
  };
 const [reload_data, setReload_Data] = useState(true);
  function CancelJoinOp(co_id, status) {
    console.log(co_id, status);
    try {
      AuthService_Operation.CancelJoinOperation(co_id, status)
        .then((res) => {
          setModalToggle({ ...modalToggle, modalSuccess: true });
          setReload_Data(!reload_data);
          setTimeout(() => {
            handleClose();
            handleClose_Modal();
          }, 1000);
        })
        .catch((err) => {
          alert("เกิดข้อผิดพลาด");
          setReload_Data(!reload_data);
        });
    } catch (err) {
      alert("เกิดข้อผิดพลาด");
    }
  }
  function center_Polygon(area) {
      area.map((value) => {
        console.log(value);
      });
      let polygon = turf.polygon([area]);
      let centroid = turf.centroid(polygon);
      console.log(centroid);
      return centroid; //return Geojson Form {tpye,props,geometry:{type,coordinates}}
    }


  const handleClick = (event) => {
    setShowTooltip(!showTooltip);
    setTarget(event.target);
  };
  const handleClose = () => {
    setShowInfomationA(false);
    setShowInfomationB(false);
    setShowAprroveDroneList(false);
    setCancancle(false);
  };

  function autocomplete(end, id) {
    const currentDate = new Date().getTime();
    const Dateend = new Date(end).getTime();
    if (Dateend < currentDate) {
      CompleteOperation(id);
    }
  }
  const CompleteOperation = (operationid) => {
    let deoperation = AuthServiceV2.CompleteOperation(operationid);
    if (deoperation != null) {
      deoperation
        .then((res) => {
          console.log(res);
          setTimeout(() => {
            window.location.reload(false);
          }, 1500);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const CancelOperation = (operationid) => {
    let deoperation = AuthServiceV2.CancelOperation(operationid);
    if (deoperation != null) {
      deoperation
        .then((res) => {
          console.log(res);
          setTimeout(() => {
            window.location.reload(false);
          }, 1500);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const DeAuthorizedOperation = (operationid) => {
    let deoperation = AuthServiceV2.DeAuthorizedOperation(operationid);
    if (deoperation != null) {
      deoperation
        .then((res) => {
          console.log(res);
          setTimeout(() => {
            window.location.reload(false);
          }, 1500);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  function formatDate(input) {
    //console.log(input)
    // Parse the date string to create a new Date object
    const date = new Date(input);

    // Extract day, month, year, hours, and minutes
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Return the formatted date
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }
  //mui table config
  const [globalFilter, setGlobalFilter] = useState("");
  const renderHeader = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <div> </div>
        {/* <h4 className="m-0">สถานะการลงทะเบียนโดรน</h4> */}
        <IconField iconPosition="left">
          <InputText
            style={{ width: "auto" }}
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="🔍  ค้นหา..."
          />
        </IconField>
      </div>
    );
  };
  const header = renderHeader();
  function filter_item_on_going(data) {
    // console.log("data:", data);
    const filteredData = data.filter(
      (item) =>
        (item.operation_status_name === "ยื่นคำขอ" ||
          item.operation_status_name === "อนุมัติ" ||
          item.operation_status_name === "หน่วยงานยกเลิกภารกิจ") &&
        (item.id
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.start_time
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.operation_status_name
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.end_time
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.drone_model
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.pilot_name
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")))
    );

    return filteredData;
  }
  function filter_item_etc(data) {
    // console.log("data:", data);
    const filteredData = data.filter(
      (item) =>
        (item.operation_status_name === "ไม่อนุมัติ" ||
          item.operation_status_name === "เสร็จภารกิจ" ||
          item.operation_status_name === "ภารกิจถูกยกเลิก") &&
        (item.id
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.start_time
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.operation_status_name
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.end_time
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.drone_model
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")) ||
          item.pilot_name
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(globalFilter.toLowerCase().split(" ").join("")))
    );

    return filteredData;
  }

  const Body_number = (data) => {
    return (
      <>
        <Button
          onClick={(e) => handleClick(e)}
          value={data.id}
          style={{
            background: "none",
            border: "none",
            color: "#575757",
            fontSize: "20px",
          }}
        >
          {data.id}
        </Button>
        <Overlay
          show={showTooltip}
          target={target}
          placement="top"
        //container={document.body}
        //containerPadding={20}
        >
          <Tooltip id="tooltip">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>คัดลอกรหัสปฏิบัติการเรียบร้อย</p>
            </div>
            {/* <div>{valuetool}</div>
          <div
            style={{ marginTop: "5px" }}
            onMouseEnter={ClipBHover}
            onClick={() => ClipBClick(valuetool)}
          >
            {clipboard_icon}
          </div> */}
          </Tooltip>
        </Overlay>
      </>
    );
  };
  const Body_Pilot_And_Drone = (item) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <FaUserAstronaut style={{ marginBottom: "5px" }} /> {item.pilot_name}
          <br />
          <GiDeliveryDrone style={{ marginBottom: "5px" }} /> {item.drone_model}
        </div>
      </div>
    );
  };
 
  const Body_Operation_Type = (data) => {
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p>{data.operation_type.split("-")[0]}</p>
        </div>
      </>
    );
  };
  const Body_Status = (data) => {
    return (
      <Plan_Status status={data.operation_status_name ?? "ติดต่อเจ้าหน้าที่"} />
    );
  };
  const Body_Information = (data) => {
    return (
      <div>
        <p
          style={{ cursor: "pointer", fontSize: "25px", margin: "0px" }}
          className="investigate-button"
          onClick={() => {
            setShowUserOperationModal(true);

            setSelectedInformation([
              data.id,
              data.operation_type,
              data.start_time,
              data.end_time,
              data.operation_area.Volume3D.outline_polygon.vertices,
              data.operation_area.Volume3D.altitude,
              data.pilot_name,
              data.drone_model,
              data.purpose,
            ]);
          }}
        >
          <img
            alt="checkdata"
            src={docgif}
            style={{ width: "40px", height: "40px" }}
          />
        </p>
        {/* <FaRegEdit
          style={{ cursor: "pointer", fontSize: "25px" }}
          className="investigate-button"
          onClick={() => {
            setShowUserOperationModal(true);

            setSelectedInformation([
              data.id,
              data.operation_type,
              data.start_time,
              data.end_time,
              data.operation_area.Volume3D.outline_polygon
                .vertices,
              data.operation_area.Volume3D.altitude,
              data.pilot_name,
              data.drone_model,
              data.purpose,
            ]);
          }}
        /> */}
      </div>
    );
  };
  const RenderLoading = () => {
    return (
      <>
        <h2 className="profile-header">ปฏิบัติการของฉัน</h2>
        <div className="user-main">
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            {" "}
            <Spinner animation="border" variant="secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      </>
    )
  }


  //fetch
  const getOperation = async () => {
    let operationlist = AuthServiceV2.Opearationdata();
    if (operationlist != null) {
      operationlist
        .then((response) => {
          console.log(response.data);
          const tempArray = [];
          const tempArray2 = [];
          const indata = response.data.operator_data;
          for (
            let operationCount = 0;
            operationCount < response.data.operator_data.length;
            operationCount++
          ) {
            tempArray.push(indata[operationCount]);
          }
          tempArray.map((data) => {
            if (data.operation_status_name === "อนุมัติ") {
              console.log(data.operation_id);
              autocomplete(data.end_time, data.operation_id);
            }
          });
          setItemsA(tempArray.reverse());
          setTimeout(() => {
            setLoading(false);
          }, 500);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  useEffect(() => {
    handleClose_Modal()
    const fetchData = async () => {
      await getOperation();


    };
    setTimeout(() => {
      fetchData()
      setLoading(false)
    }, 500);

  }, [loading]);
  return (
    <>
      {loading ? <RenderLoading /> :
        <>
          <h2 className="profile-header">ปฏิบัติการของฉัน</h2>
          <div className="table-card-header" style={{ marginBottom: "35px" }}>
            <h4 className="header-main" style={{ color: "white" }}>
              {t('operationlist.headtitle')}
            </h4>
          </div>
          <DataTable
            value={filter_item_on_going(itemsA)}
            paginator
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rows={5}
            rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
            header={header}
            emptyMessage="ไม่มีข้อมูล"
            tableStyle={{ minWidth: "50rem" }}
            style={{ fontFamily: "Kanit" }}
          >
            <Column
              header={t('operationlist.OperationCode')}
              body={Body_number}
              field={`id`}
              sortable
              filterField="id"
              dataType="date"
              bodyStyle={{ alignItems: "center", textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
            <Column
              header={t('operationlist.pilotandUAV')}
              body={Body_Pilot_And_Drone}
              field={`pilot_name`}
              sortable
              bodyStyle={{ alignItems: "center", textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
         
            <Column
              header={t('operationlist.type')}
              body={Body_Operation_Type}
              field="operation_type"
              sortable
              filterField="operation_type"
              //sortFunction={customSort}
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
            <Column
              header={t('operationlist.status')}
              body={Body_Status}
              field={`operation_status_name`}
              sortable
              filterField="operation_status_name"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
            <Column
              header={t('operationlist.checkdata')}
              body={Body_Information}
              field={`built_in_rid`}
              sortable
              filterField="built_in_rid"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
          </DataTable>

          <div
            className="table-card-header"
            style={{ marginTop: "50px" }}
          >
            <h4 className="header-main" style={{ color: "white" }}>
              {t('operationlist.successtitle')}
            </h4>
          </div>
          <div style={{ textAlign: "end", marginTop: "35px" }}>
            {/* <p>จำนวน {itemsA.length}</p> */}
          </div>

          <DataTable
            value={filter_item_etc(itemsA)}
            paginator
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rows={5}
            rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
            header={header}
            emptyMessage="ไม่พบข้อมูล"
            tableStyle={{ minWidth: "50rem" }}
            style={{ fontFamily: "Kanit" }}
          >
            <Column
              header={t('operationlist.OperationCode')}
              body={Body_number}
              field={`id`}
              sortable
              filterField="id"
              dataType="date"
              bodyStyle={{ alignItems: "center", textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
            <Column
              header={t('operationlist.pilotandUAV')}
              body={Body_Pilot_And_Drone}
              field={`pilot_name`}
              sortable
              bodyStyle={{ alignItems: "center", textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
    
            <Column
              header={t('operationlist.type')}
              body={Body_Operation_Type}
              field="operation_type"
              sortable
              filterField="operation_type"
              //sortFunction={customSort}
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
            <Column
              header={t('operationlist.status')}
              body={Body_Status}
              field={`operation_status_name`}
              sortable
              filterField="operation_status_name"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
            <Column
              header={t('operationlist.checkdata')}
              body={Body_Information}
              field={`built_in_rid`}
              sortable
              filterField="built_in_rid"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
          </DataTable>
          {showInfomationA === true && (
            <Modal
              show={showInfomationA}
              onHide={handleClose}
              aria-labelledby="contained-modal-title-vcenter"
              size="xl"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  {/* ลำดับที่ {selectedInformation[0]}  */}
                  รหัสการปฏิบัติการ {selectedInformation[1]}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ margin: "0", padding: "0" }}>
                <div>
                  <MapContainer
                    center={
                      center_Polygon(selectedInformation[2]).geometry
                        .coordinates
                    }
                    zoom={13}
                    keyboard={true}
                    style={{ width: "100%", height: "50vh", zIndex: 1 }}
                  >
                    <TileLayer
                      style={{ zIndex: 2 }}
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Polygon
                      pathOptions={{ color: "blue" }}
                      positions={selectedInformation[2]}
                    />
                  </MapContainer>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div style={{ width: "100%", height: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <h4>
                        เวลาเริ่มต้น : {formatDate(selectedInformation[3])}
                      </h4>
                    </div>
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <h4>
                        เวลาสิ้นสุด : {formatDate(selectedInformation[4])}
                      </h4>
                    </div>
                  </div>

                  {selectedInformation[5] === "ยื่นคำขอ" ? (
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Button
                        className="custom-btn btnCancel"
                        onClick={() => {
                          CancelOperation(selectedInformation[0]);
                          // window.location.reload(false);
                        }}
                      >
                        ยกเลิกคำขอ
                      </Button>
                    </div>
                  ) : selectedInformation[5] === "อนุมัติ" ? (
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      {cancancle ? (
                        <>
                          <div
                            style={{
                              width: "50%",
                              height: "100%",
                              textAlign: "center",
                            }}
                          >
                            <Button
                              className="custom-btn btnCancel"
                              onClick={() => {
                                DeAuthorizedOperation(selectedInformation[0]);
                                handleClose();
                              }}
                            >
                              ยกเลิกแผนการบิน
                            </Button>
                          </div>
                          <div
                            style={{
                              width: "50%",
                              height: "100%",
                              textAlign: "center",
                            }}
                          >
                            <Button
                              className="custom-btn btnEdit2"
                              onClick={() => {
                                Navigate("/user/drone/updatepolygon", {
                                  state: {
                                    passedOperationID: selectedInformation[0],
                                    passedArea: selectedInformation[2],
                                    passedTimeStart: selectedInformation[3],
                                    passedTimeEnd: selectedInformation[4],
                                  },
                                });
                                handleClose();
                              }}
                            >
                              แก้ไขแผนการบิน
                            </Button>
                          </div>
                        </>
                      ) : (
                        <div
                          style={{
                            width: "50%",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          <Button
                            variant="success"
                            onClick={() => {
                              CompleteOperation(selectedInformation[0]);
                              handleClose();
                            }}
                          >
                            <h4 style={{ color: "white" }}>เสร็จภารกิจ</h4>
                          </Button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Button className="custom-btn btnDisable" disabled>
                        ยกเลิกคำขอ
                      </Button>
                    </div>
                  )}
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {showInfomationB === true && (
            <Modal
              show={showInfomationB}
              onHide={handleClose}
              aria-labelledby="contained-modal-title-vcenter"
              size="xl"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  {/* ลำดับที่ {selectedInformation[0]}  */}
                  รหัสการปฏิบัติการ {selectedInformation[1]}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ margin: "0", padding: "0" }}>
                <div>
                  <MapContainer
                    center={
                      center_Polygon(selectedInformation[2]).geometry
                        .coordinates
                    }
                    zoom={15}
                    keyboard={true}
                    style={{ width: "100%", height: "50vh", zIndex: 1 }}
                  >
                    <TileLayer
                      style={{ zIndex: 2 }}
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Polygon
                      pathOptions={{ color: "blue" }}
                      positions={selectedInformation[2]}
                    />
                  </MapContainer>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div
                  style={{ width: "100%", height: "100%", fontSize: "22px" }}
                >
                  <div className="modal-body-grid2">
                    <div className="grid-item">
                      เวลาเริ่มต้น : {selectedInformation[3]}
                    </div>
                    <div className="grid-item">
                      เวลาสิ้นสุด : {selectedInformation[4]}
                    </div>
                  </div>
                  <div className="modal-body-grid2">
                    <div className="grid-item">
                      จำนวนโดรน : {selectedInformation[6]}
                    </div>
                    <div className="grid-item">
                      ความสูง : {selectedInformation[7]}
                    </div>
                  </div>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {showApproveDroneList === true && (
            <Modal
              show={showApproveDroneList}
              onHide={handleClose}
              aria-labelledby="contained-modal-title-vcenter"
              size="xl"
              centered
            >
              <Modal.Body style={{ margin: "0", padding: "0" }}>
                <div
                  className="container-main"
                  style={{ width: "90%", marginLeft: "5%" }}
                >
                  <div style={{ textAlign: "end" }}>
                    <p>จำนวน {member_joining.length} รายการ</p>
                  </div>
                  <Table
                    striped
                    responsive
                    overflow
                    bordered={false}
                    hover
                    className="table-main"
                    style={{
                      marginTop: "0px",
                    }}
                  >
                    <thead>
                      <tr>
                        <th className="table-space" style={{ width: "5%" }}>
                          ลำดับ
                        </th>
                        <th className="table-space" style={{ width: "25%" }}>
                          ชื่อนักบิน
                        </th>
                        <th className="table-space">โมเดลของโดรน</th>
                        <th className="table-space" style={{ width: "15%" }}>
                          สถานะ
                        </th>
                        <th className="table-space" style={{ width: "15%" }}>
                          ยกเลิกนักบิน
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {member_joining !== undefined
                        ? member_joining.map((item, index) => (
                            <>
                              <tr key={index}>
                                <td className="table-space">{index + 1}</td>
                                <td className="table-space">
                                  {item.pilot_name}
                                </td>
                                <td className="table-space">
                                  {item.drone_brand_model}
                                </td>
                                <td
                                  className="table-space"
                                  style={{
                                    color: (() => {
                                      switch (item.status_name) {
                                        case "อนุมัติ":
                                        case "อนุญาตให้ขึ้นบิน":
                                        case "เสร็จภารกิจ":
                                          return "#008000";
                                        case "ภารกิจถูกยกเลิก":
                                        case "ยกเลิกภารกิจ":
                                        case "ไม่อนุมัติ":
                                        case "หน่วยงานยกเลิกภารกิจ":
                                          return "#FF0000";
                                        default:
                                          return "#FF8C00";
                                      }
                                    })(),
                                  }}
                                >
                                  {item.status_name ?? "ติดต่อเจ้าหน้าที่"}
                                </td>
                                <td
                                  className="table-space"
                                  onClick={() => {
                                    console.log("Approved");
                                    CancelJoinOp(item.operation_co_id, 3);
                                  }}
                                >
                                  <button
                                    className="custom-btn btnCancel"
                                    style={{
                                      fontSize: "16px",
                                      width: "120px",
                                      height: "30px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    ยกเลิก
                                  </button>
                                </td>
                              </tr>
                            </>
                          ))
                        : null}
                    </tbody>
                  </Table>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div style={{ width: "100%", height: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                    }}
                  ></div>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {showUserOperationModal && (
            <UserOperationContentModal
              toggleModal={showUserOperationModal}
              onHide={handleToggleUserOperationModal}
              content={{
                id: selectedInformation[0],
                type: selectedInformation[1],
                start: selectedInformation[2],
                end: selectedInformation[3],
                positions: selectedInformation[4],
                height: selectedInformation[5],
                pilot_name: selectedInformation[6],
                drone_model: selectedInformation[7],
                purpose: selectedInformation[8],
              }}
            />
          )}

          <Modal
            show={showErroroperation}
            onHide={() => setShowErroroperation(false)}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header>
              <Modal.Title>แจ้งเตือน</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ท่านยังไม่ได้ลงทะเบียนโดรน หรือ โดรนของท่านยังไม่ได้รับการอนุมัติ{" "}
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => {
                  Navigate("/user/drone/regisDrone");
                }}
              >
                หน้าลงทะเบียนโดรน
              </Button>
              <Button
                onClick={() => {
                  Navigate("/user/drone/statusDrone");
                }}
              >
                หน้าสถานะการลงทะเบียน
              </Button>
            </Modal.Footer>
          </Modal>
          {showUserOperationModal && (
            <UserOperationContentModal
              toggleModal={showUserOperationModal}
              onHide={handleToggleUserOperationModal}
              content={{
                id: selectedInformation[0],
                type: selectedInformation[1],
                start: selectedInformation[2],
                end: selectedInformation[3],
                positions: selectedInformation[4],
                height: selectedInformation[5],
                pilot_name: selectedInformation[6],
                drone_model: selectedInformation[7],
                purpose: selectedInformation[8],
              }}
            />
          )}
        </>
        
      }
    </>
  );
};

